var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('ComNar',{attrs:{"title":"兑换充值"}}),_c('Card'),_c('div',{staticClass:"merge-box"},[_c('Merge')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }